import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_EDIT_POST_MUTATION = gql`
  mutation Post($components: String!, $postCategory: [String], $postDescription: ObjectPostDescriptionInput, $slugName: String!, $postName: String, $rolesAllowed: [String], $active: Boolean!, $noIndex: Boolean, $scheduledPublishDate: String, $type: String, $requiresCompleteRegistration: Boolean) {
    postEditPost(components: $components, postCategory: $postCategory, postDescription: $postDescription, slugName: $slugName, postName: $postName, rolesAllowed: $rolesAllowed, active: $active, noIndex: $noIndex, scheduledPublishDate: $scheduledPublishDate, type: $type, requiresCompleteRegistration: $requiresCompleteRegistration) {
      isAuth
      isEdited
      slugName
      isActive
    }
  }
`;

const GET_POST_BY_SLUG = gql`
  query Get($slugName: String!) {
    getPostBySlug(slugName: $slugName) {
      isAuth
      post {
        _id
        postCategory
        postDescription {
          title {
            en
            es
            ca
            pt
          }
          subtitle {
            en
            es
            ca
            pt
          }
          description {
            en
            es
            ca
            pt
          }
          image {
            en
            es
            ca
            pt
          }
          imageSocial {
            en
            es
            ca
            pt
          }
          cta {
            url
            text {
              en
              ca
              es
              pt
            }
            isDisabled
          }
          overlayImage
          removeBodyChildrenMargin
          loyaltyPoints
          spotifyArtistIds
          authors{
            name
            slug
          }
          relatedArtists {
            name
            slug
          }
          relatedMagazine {
            title
            slugName
          }
          itemLayout
          tags
          date
        }
        active
        noIndex
        scheduledPublishDate
        slugName
        postName
        rolesAllowed
        type
        components
        requiresCompleteRegistration
      }
    }
  }
`;

const postEditPost = async ({ components, postCategory, postDescription, slugName, type, active, postName, rolesAllowed, noIndex, requiresCompleteRegistration, scheduledPublishDate }) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_EDIT_POST_MUTATION,
        variables: {
          components,
          postCategory,
          postDescription,
          slugName,
          postName,
          rolesAllowed,
          type,
          active,
          noIndex,
          scheduledPublishDate,
          requiresCompleteRegistration,
        },
        fetchPolicy: 'no-cache',
        partialRefetch: false,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GET_POST_BY_SLUG,
            variables: { slugName },
            fetchPolicy: 'cache-and-network',
            awaitRefetchQueries: true,
          },
        ],
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { postEditPost: postEditPostValidationData } } = result;

    if (postEditPostValidationData) return postEditPostValidationData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postEditPostValidationData = null`);
    return null;

  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postEditPost Error: ${error}`);
    return null;
  }
};

export default postEditPost;
